document.addEventListener("DOMContentLoaded", function() {
	$(document).ready(function(){

		const focusVisible = document.focusVisible;
		if($("#wp--skip-link--target").length > 0){
			var elementTop = $("#wp--skip-link--target").offset().top + $("#wp--skip-link--target").height();
		}

		document.querySelectorAll('.quick-access a[href^="#"]').forEach(function (link) {
			link.addEventListener('click', function (e) {
				const targetId = this.getAttribute('href').slice(1);
				const target = document.getElementById(targetId);

				if (target) {
					if (target.id === 'accessibility-settings') {
						const link = target.querySelector('a');
						if (link) {
							link.focus();
							return;
						}
					}
					setTimeout(() => {
						target.setAttribute('tabindex', '-1');
						target.focus();
					}, 100);
				}
			});
		});

		$(".access a").on("click", function(e){
			$("#accessconfig").find('button').click();
			e.preventDefault();
			return false;
		});

		const buttons = document.querySelectorAll('.read_more_button');
		buttons.forEach(button => {
			button.addEventListener('click', () => {
				const expanded = button.getAttribute('aria-expanded') === 'true';
				const answer = document.getElementById(button.getAttribute('aria-controls'));

				button.setAttribute('aria-expanded', String(!expanded));
				answer.hidden = expanded;
			});
		});
	});
});